/**
 * @module app.ext.mcg-informed
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getMcgInformedQuestionTypes(): DynamicViews {
    return {
        'MultipleSelect':
            [{ title: 'Check List (Multi-Select)', url: PLATFORM.moduleName('app/ext/mcg-informed/question-checkbox') }],
        'SingleSelect':
            [{ title: 'Check List (Single Select)', url: PLATFORM.moduleName('app/ext/mcg-informed/question-radio') }],
        'FreeText':
            [{ title: 'Single-Line Text', url: PLATFORM.moduleName('app/ext/mcg-informed/question-textbox') }],
        'DEDate':
            [{ title: 'Date (Month/Day/Year)', url: PLATFORM.moduleName('app/ext/mcg-informed/question-date') }],
        'DENumeric':
            [{ title: 'Number (Integer)', url: PLATFORM.moduleName('app/ext/mcg-informed/question-number') }]
    };
}
